import React from 'react';
import { connect } from 'react-redux';
import {
    fashionSizeSelected,
    sewpatOptionSelected,
    sewpatOptionsSelected,
    selectProduct,
    selectFabric,
} from '../../actions/cart';
import { hasError } from '../../reducers/cart';
import { getCurrentPatternId } from '../../reducers/currentPattern';
import {
    getActiveFabricId,
    getActiveFabricMaterial,
    getActiveFabricProcessingTime,
    getActiveFabricTitle, getFabrics,
} from '../../reducers/fabrics';
import { getMessage } from '../../reducers/i18n';
import { getPatternTitle } from '../../reducers/patterns';
import { getActiveFabricPriceScale } from '../../reducers/prices';
import {
    getActiveProductId,
    getActiveProductSelectedValues,
    getProducts,
} from '../../reducers/products';
import {
    getActiveSewpat,
    getActiveSewpatOptions,
    getActiveSewpatSelectedValues,
    getFabricDisplayLengthBySize,
    getFashionSize,
    getSelectedSewpatOptions,
    getSewpatSizes,
    sewpatHasMultipleOptions,
} from '../../reducers/sewpats';

import ChildWrapper from '../styles/AddToCartChildWrapper';
import Wrapper from '../styles/AddToCartWrapper';
import AddToCartForm from './AddToCartForm';
import SelectedValues from './SelectedValues';
import SizeSelection from './SizeSelection';
import FabricSelection from './FabricSelection';
import FabricChipSelection from './FabricChipSelection';

const AddToCart = props => {
    const handleSizeSelection = size => props.sizeSelected(size);
    const handleOptionsSelection = options => props.optionsSelected(options);
    return (
        <React.Fragment>
            <Wrapper
                itemProp='offers' itemScope itemType='http://schema.org/Offer'
                className='stolo-cart-wrapper'
            >
                <SizeSelection
                    handleSizeChange={handleSizeSelection}
                    wrapper={ChildWrapper}
                    sizes={props.sizes}
                    multisize
                    size={props.size}
                    withOptions={props.hasOptions}
                    options={props.sewpatOptions || {}}
                    handleOptionsChange={handleOptionsSelection}
                    activeOptions={props.activeOptions}
                    products={props.products}
                    activeProductId={props.activeProductId}
                    handleProductChange={props.selectProduct}
                    disableSizeSelection={props.disableSizeSelection}
                    fabrics={props.fabrics}
                    activeFabricId={props.activeFabricId}
                    handleFabricChange={props.fabricSelected}
                />
                <SelectedValues
                    values={props.selectedValues}
                    wrapper={ChildWrapper}
                    patternTitle={props.patternTitle}
                    fabricTitle={props.fabricTitle}
                />
                <AddToCartForm
                    wrapper={ChildWrapper}
                    hasError={props.hasError}
                    message={props.errorMessage}
                />
            </Wrapper>
        </React.Fragment>
    );
};

const mapDispatchToProps = dispatch => (
    {
        sizeSelected: size => dispatch(fashionSizeSelected(size)),
        optionsSelected: options => dispatch(sewpatOptionsSelected(options)),
        selectProduct: productId => dispatch(selectProduct(productId)),
        fabricSelected: fabricId => dispatch(selectFabric(fabricId)),
    }
);

const makeMapStateToProps = initialstate => {
    const patternid = getCurrentPatternId(initialstate);
    const fabrics = getFabrics(initialstate);
    const sizes = getSewpatSizes(initialstate);
    const errorMessage = getMessage(
        initialstate,
        'FABRIC_LENGTH_SELECTION_ERROR',
    );
    const patternTitle = getPatternTitle(initialstate, patternid);
    const patternDescription = getCurrentPatternId(initialstate, patternid);
    var sewpatSelectedValues = getActiveSewpatSelectedValues(initialstate);
    const sewpat = getActiveSewpat(initialstate);

    const fabricTitleLabel = getMessage(initialstate, 'FABRIC_TITLE_LABEL');
    const fabricMaterialLabel = getMessage(
        initialstate,
        'FABRIC_MATERIAL_LABEL',
    );
    const fabricProcessingLabel = getMessage(initialstate, 'PROCESSING_TIME');
    const patternLabel = getMessage(initialstate, 'PATTERN_TITEL_LABEL');
    const sewpatSizeLabel = getMessage(
        initialstate,
        'SEWPAT_FASHION_SIZE_LABEL',
    );
    const fabricLengthLabel = getMessage(initialstate, 'FABRIC_LENGTH_LABEL');
    const sewpatOptions = getActiveSewpatOptions(initialstate);
    const products = getProducts(initialstate);

    const mapStateToProps = state => {
        const fabricTitle = getActiveFabricTitle(state);
        const fabricMaterial = getActiveFabricMaterial(state);
        const fabricProcessingTime = getActiveFabricProcessingTime(state);
        const size = getFashionSize(state);
        const hasMultipleOptions = sewpatHasMultipleOptions(sewpat);
        const selectedVariations = getSelectedSewpatOptions(state);
        const fabricLength = getFabricDisplayLengthBySize(
            sewpat,
            size,
            selectedVariations,
        );
        const productSelectedValues = getActiveProductSelectedValues(state);
        const activeProductId = getActiveProductId(state);
        const activeFabricId = getActiveFabricId(state);
        var selectedValues = {};

        if (activeProductId === 'schnoff' || activeProductId === 'fabric') {
            selectedValues = Object.assign({}, sewpatSelectedValues, {
                [patternLabel]: patternTitle,
                [fabricMaterialLabel]: `${fabricTitle} (${fabricMaterial})`,
                [fabricProcessingLabel]: fabricProcessingTime,
                [fabricLengthLabel]: `${fabricLength}cm`,
            },
                productSelectedValues,
            );
        }

        if (activeProductId === 'sewingpattern') {
            selectedValues =
                Object.assign({}, sewpatSelectedValues, productSelectedValues);
        }

        return (
        {
            patternid,
            patternDescription,
            selectedValues,
            hasError: hasError(state),
            errorMessage,
            sizes,
            size,
            fabricTitle,
            patternTitle,
            sewpatOptions,
            hasOptions: hasMultipleOptions,
            activeOptions: selectedVariations,
            products,
            activeProductId,
            disableSizeSelection: activeProductId === 'sewingpattern',
            fabrics,
            activeFabricId,
        }
        );
    };
    return mapStateToProps;
};

export default connect(makeMapStateToProps, mapDispatchToProps)(AddToCart);



// WEBPACK FOOTER //
// ./src/components/addtocart/AddToCart.js